import React from 'react'
import { OUTBOUND_LIMIT_HINT } from '../../../../shared/ticketAttachmentLimits.js'

/** The "Attach photos" button and its limit hint. `photos` comes from useOutboundPhotos. */
export function OutboundPhotoPicker({ photos }) {
  return (
    <>
      <label className="btn btn-sm btn-secondary" style={{ fontSize: '0.8rem', cursor: 'pointer', margin: 0 }}>
        Attach photos
        <input
          type="file"
          accept="image/*"
          multiple
          disabled={photos.preparing}
          style={{ display: 'none' }}
          onChange={photos.addFromInput}
        />
      </label>
      <span className="text-muted" style={{ fontSize: '0.75rem' }}>
        {photos.preparing ? 'Preparing photos...' : OUTBOUND_LIMIT_HINT}
      </span>
    </>
  )
}

/** The refusal message and the attached files, each with a remove button. */
export function OutboundPhotoList({ photos }) {
  return (
    <>
      {photos.error && (
        <div role="alert" style={{ fontSize: '0.8rem', marginTop: 'var(--space-1)', color: 'var(--color-error)' }}>
          {photos.error}
        </div>
      )}
      {photos.files.map((file, index) => (
        <div key={`${file.name}-${index}`} style={{ fontSize: '0.8rem', marginTop: 'var(--space-1)' }}>
          {file.name}
          <button
            aria-label={`Remove ${file.name}`}
            onClick={() => photos.removeAt(index)}
            style={{ marginLeft: 6, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-error)', fontWeight: 'bold', padding: 0 }}
          >
            &times;
          </button>
        </div>
      ))}
    </>
  )
}
